/**
 * Counter Mode Configuration
 *
 * Constants for Counter/Quick Service mode.
 * These values should match the seeded data in the database.
 */

// Table and Section names for Counter mode
export const COUNTER_TABLE_NAME = 'MAVERICK_COUNTER';
export const COUNTER_SECTION_NAME = 'MAVERICK_COUNTER';

// Default values for counter orders
export const COUNTER_DEFAULTS = {
  tableName: COUNTER_TABLE_NAME,
  sectionName: COUNTER_SECTION_NAME,
  split: 'A',
  pax: 1,
  capacity: 1,
  status: 'available',
};

// Helper to check if a table is the counter table
export const isCounterTable = (table) => {
  if (!table) return false;
  const tableName = (table.tableNumber || table.name || '').toUpperCase();
  return tableName === COUNTER_TABLE_NAME;
};

// Helper to check if a section is the counter section
export const isCounterSection = (section) => {
  if (!section) return false;
  const sectionName = (section.name || section.sectionName || '').toUpperCase();
  return sectionName === COUNTER_SECTION_NAME;
};
